import { AxiosInstance } from 'axios';
import { BaseRequest } from '@trukt/types/BaseRequest';
import { PaginatedQueryParams } from '@trukt/types/PaginatedQueryParams';
import { PaginatedResults } from '@trukt/types/PaginatedResults';
import { PartyLiterals } from '@trukt/types/Party';
import { OrderParty } from '@trukt/types/OrderParty';
import { OrderPartyChargeService } from './services';

interface OrderPartiesQueryParams extends PaginatedQueryParams {
  type?: PartyLiterals;
}

export type OrderPartiesRequest = Pick<
  BaseRequest<OrderPartiesQueryParams, void, { orderGuid: string }>,
  'routeParams' | 'queryParams'
>;
export type OrderPartiesResponse = PaginatedResults<OrderParty>;

export class OrderPartiesService {
  instance: AxiosInstance;
  charge: OrderPartyChargeService;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
    this.charge = new OrderPartyChargeService(instance);
  }

  search(request: OrderPartiesRequest) {
    return this.instance.get<OrderPartiesResponse>(
      `/orders/${request.routeParams.orderGuid}/parties`,
      {
        params: request.queryParams,
      },
    );
  }
}
